/**
 * SECTION — GLOBAL STICKY STEPS
 *
 * Scroll-spy: highlights the rail nav link of the step sitting at the rail
 * block's own height (.is-active + aria-current), so the reference follows the
 * rail wherever it is — sticky column on desktop, pinned bar on mobile.
 * Progressive enhancement: the rail links are plain in-page anchors.
 *
 * Progress bar: .is-pinned on the rail block while the steps are on screen.
 */
(function () {
  'use strict';

  function scrollSpy(section) {
    var steps = section.querySelectorAll('[data-step]');
    var links = section.querySelectorAll('[data-step-link]');
    var polas = section.querySelectorAll('[data-step-pola]');
    var rail = section.querySelector('[data-step-progress]');
    if (!steps.length || !links.length || !rail) return;

    function setActive(id) {
      links.forEach(function (link) {
        var on = link.dataset.stepLink === id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
      polas.forEach(function (pola) {
        pola.classList.toggle('is-active', pola.dataset.stepPola === id);
      });
    }

    function update() {
      var line = rail.getBoundingClientRect().bottom;
      var current = steps[0];
      steps.forEach(function (step) {
        if (step.getBoundingClientRect().top <= line) current = step;
      });
      setActive(current.id);
    }

    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        update();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function pinProgress(section) {
    var progress = section.querySelector('[data-step-progress]');
    var list = section.querySelector('.method-detail-steps');
    if (!progress || !list || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      progress.classList.toggle('is-pinned', entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -60% 0px', threshold: 0 });

    observer.observe(list);
  }

  function init() {
    var section = document.querySelector('.method-detail');
    if (!section) return;

    scrollSpy(section);
    pinProgress(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
